module.exports = __webpack_public_path__ + "static/media/search.c570d1b8.svg";